import React, { useEffect, useState } from "react";
import axios from "axios";

import { Typography, Empty } from "antd";
import { BarChartOutlined } from "@ant-design/icons";

import { Row, Col, Card } from "antd";
import "./css/dashboard.css";

const { Title, Text } = Typography;

const Dashboard_he = prop => {
  return (
    <React.Fragment>
      {/* Page Title */}
      <div style={{ marginBottom: 24 }}>
        <Title level={2} className="gradient-text">
          Health and well-being of society / Excellent management
        </Title>
      </div>

      {/* Empty State */}
      <div
        style={{
          height: "720px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#fafafa",
          borderRadius: 16,
          border: "1px dashed #d9d9d9"
        }}
      >
        <Empty
          image={
            <BarChartOutlined
              style={{
                fontSize: 72,
                color: "#91caff"
              }}
            />
          }
          imageStyle={{ height: 80 }}
          description={
            <>
              <Title level={4} style={{ marginBottom: 8 }}>
                ยังไม่มีข้อมูลแสดงผล
              </Title>
              <Text type="secondary">
                ข้อมูลจะปรากฏเมื่อมีการบันทึกและประมวลผลในระบบ
              </Text>
            </>
          }
        />
      </div>
    </React.Fragment>
  );
};

export default Dashboard_he;
